'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for storing information about the subject of the universal sidebar query
 *
 * @param {object} value.definition               the definition of the subject
 * @param {string} value.primaryDisplayLabel      the formatted primary display label for the subject
 * @param {string} value.objectType               the object type of the subject
 * @param {string} value.objectId                 the id of the subject
 */

export const SidebarSubjectContext = /*#__PURE__*/createContext({
  definition: null,
  primaryDisplayLabel: null,
  primaryDisplayProperty: null,
  objectType: null,
  objectId: null
});
export const useSidebarSubjectContext = () => useContext(SidebarSubjectContext);
SidebarSubjectContext.Provider.propTypes = {
  value: PropTypes.oneOfType([PropTypes.shape({
    definition: PropTypes.shape({
      id: PropTypes.string,
      pluralForm: PropTypes.string,
      singularForm: PropTypes.string
    }).isRequired,
    allProperties: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      source: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      __typename: PropTypes.string.isRequired
    })),
    primaryDisplayLabel: PropTypes.string.isRequired,
    primaryDisplayProperty: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string
    }),
    objectType: PropTypes.string.isRequired,
    objectId: PropTypes.string.isRequired
  }).isRequired, PropTypes.shape({
    loading: PropTypes.bool.isRequired
  })])
};